export const meta = { id: 'O12', slug: 'gestao-treinamentos', title: 'Conheça Gestão de Treinamentos', description: 'Entenda a estrutura Treinamento → Módulos → Aulas → Conteúdo.', profile: 'owner', category: 'treinamentos', type: 'screen', status: 'published', order: 420, keywords: ['treinamentos','módulos','aulas','conteúdo'], previous: 'O11', next: 'O13', related: ['O13','O14','O15','A09'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Conheça Gestão de Treinamentos

Treinamentos organizam conteúdos de aprendizagem em uma sequência estruturada.

**Treinamento → Módulos → Aulas → Conteúdo**

<HelpImage pendingId="O12.1" alt="Tela de Gestão de Treinamentos" />

O Owner cria e organiza a experiência. O Aluno consome as aulas e registra seu progresso.
